(function () {
  // Machines page: size filter + deep link ?m=20
  var filt = document.getElementById('sizeFilter');
  function setSizeFilter(size) {
    if (!filt) return;
    var bs = filt.querySelectorAll('button');
    for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('on', bs[i].getAttribute('data-size') === size);
    var rows = document.querySelectorAll('.sizerow');
    for (var j = 0; j < rows.length; j++) rows[j].classList.toggle('hide', size !== 'all' && rows[j].getAttribute('data-size') !== size);
  }
  if (filt) {
    filt.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) setSizeFilter(b.getAttribute('data-size')); });
    var m = /[?&]m=(17|20|24|26)/.exec(location.search);
    if (m) { setSizeFilter(m[1]); var el = document.getElementById('m' + m[1]); if (el && el.scrollIntoView) setTimeout(function () { el.scrollIntoView(); }, 0); }
  }

  // Contact page: preselect interest from ?i=… and prefill the message
  var sel = document.getElementById('f-config');
  var msg = document.getElementById('f-msg');
  if (sel) {
    var qi = /[?&]i=([A-Za-z0-9-]+)/.exec(location.search);
    if (qi) { sel.value = qi[1]; if (sel.value !== qi[1]) sel.value = 'help'; }
    var cfgTxt = null;
    try { cfgTxt = sessionStorage.getItem('trax-cfg'); } catch (e) {}
    if (msg && !msg.value) {
      if (sel.value === 'custom' && cfgTxt) msg.value = cfgTxt;
      else if (/^TRAX-/.test(sel.value)) msg.value = (msg.getAttribute('data-std') || '') + sel.value;
    }
    if (document.querySelector('#quoteForm .form-status:not(.err)')) { try { sessionStorage.removeItem('trax-cfg'); } catch (e) {} }
  }

  // Support page: documents not yet uploaded
  var soon = document.querySelectorAll('a.doc.soon');
  for (var k = 0; k < soon.length; k++) soon[k].addEventListener('click', function (ev) { ev.preventDefault(); });
})();
